export default __webpack_public_path__ + "pgnv-assets/5ce9c7f0c0bc0171d3d4e9fdfb2a2b19.png";